import React from "react";
import Speech from 'speak-tts';
import audioIcon from '../../assets/images/audio.svg';
import { makeStyles } from '@material-ui/core/styles'; 

type AudioButtonProps = {
  content: string;
}
const speech = new Speech(); // will throw an exception if not browser supported
if (speech.hasBrowserSupport()) { // returns a boolean
  console.log("speech synthesis supported");
}
speech.init({ 'voice': 'Google US English' }).then((data: any) => {
  // The "data" object contains the list of available voices and the voice synthesis params
  // console.log("Speech is ready, voices are available", data);
}).catch((e: Error) => {
  console.error("An error occured while initializing : ", e);
});

const useStyles = makeStyles(theme => ({
  audioButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    outline: 'inherit',
    color: '#9D7E47',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    gridArea: 'audioButton',
  }
}));


export const AudioButton: React.FC<AudioButtonProps> = ({ content }) => {

  const classes = useStyles();

  return (
    <button className={classes.audioButton} onClick={() => {
      if (speech.speaking()) {
        speech.cancel();
      } else {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = content;
        speech.speak({ text: tmp.textContent || tmp.innerText || "" });
      }

    }}>
      <img alt="" src={audioIcon} />
    </button>
  );
};